

































import { Component, Prop, Vue } from 'vue-property-decorator';

export interface UploadRadio {
  id: string;
  value: string | number;
}

@Component({
  components: {},
})
export default class UploadQuestionRadio extends Vue {
  @Prop()
  radios!: UploadRadio[];

  get currentType() {
    const radio = this.radios.find(radio => {
      return radio.id === 'questionType';
    });
    if (radio) {
      return radio.value;
    } else {
      return 'subjective';
    }
  }

  get currentDifficulty() {
    const radio = this.radios.find(radio => {
      return radio.id === 'difficulty';
    });
    if (radio) {
      return radio.value;
    } else {
      return 2;
    }
  }

  questionTypes = [
    {
      label: 'Objective',
      value: 'objective',
    },
    {
      label: 'Subjective',
      value: 'subjective',
    },
  ];

  difficulties = [
    {
      label: 'Easy',
      value: 1,
    },
    {
      label: 'Medium',
      value: 2,
    },
    {
      label: 'Hard',
      value: 3,
    },
  ];

  radioClick(radioType: string, value: string) {
    const radio = this.radios.find(radio => {
      return radio.id === radioType;
    });

    if (radio) {
      radio.value = value;
    }
  }
}
